import React, { useState } from "react";
import logo from "../Images/Image/cropped-Gemini_Generated_Image_m4jpbtm4jpbtm4jp-removebg-preview.png";
import { Link } from "react-router-dom";
import "../css/Header.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <>
      {/* TOP INFO BAR */}
      <div className="topbar">
        <div className="topbar-left">
          ✉ management@sktconstructions.in
          <span>📍 Singra Mau, PO, Sahson, Singra Mau, Prayagraj, Uttar Pradesh 221507</span>
        </div>

        <div className="topbar-right">
          <span>📘</span>
          <span>🐦</span>
          <span>📸</span>
          <span>▶️</span>
          <span>📌</span>
          <button className="quote-btn">GET A QUOTE</button>
        </div>
      </div>

      {/* MAIN HEADER */}
      <header className="header">
        <div className="logo">
          <img src={logo} alt="SKT Construction" />
        </div>

        {/* <div className="menu-toggle" onClick={toggleMenu}>
          ☰
        </div> */}

        <nav className={`nav ${menuOpen ? "active" : ""}`}>
          <a href="/">HOME</a>
          <a href="/about">ABOUT US</a>
          <a href="/projects">PROJECTS</a>
          <a href="/rental">SERVICES</a>
          <a href="#">BLOG</a>
          <a href="/contact">CONTACT</a>
        </nav>

        <div className="header-right">
          <span className="phone-icon">📞</span>
          <div>
            <small style={{ display: 'block', marginBottom: '5px' }}>BOOK APPOINTMENT</small>
            <strong>+91 9244202021</strong>
          </div>
        </div>
      </header>
    </>
  );
}
